import React from 'react'

export default function Terms() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">Terms of Service</h2>
        <p className="kv">Last updated: <strong>Nov 1, 2025</strong></p>
        <p className="kv">By using this site you agree to our terms. Replace this with full legal text prepared by counsel.</p>
      </section>
    </div>
  )
}
